module.exports = __webpack_public_path__ + "img/mode-contrast.b26ad8a9.png";